import styled from "styled-components";

import { Summary } from "features/shared/styles/typography/Summary.styled";

const ProcessingCard = styled.div`
  max-width: 500px;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};

  ${Summary} {
    margin-bottom: 24px;
  }

  img {
    margin-right: 8px;
  }

  .container {
    display: flex;
    align-items: center;
  }

  .file-name {
    margin-bottom: 8px;
  }
`;

export default ProcessingCard;
